import React from "react";
import {CustomInput, Dropdown, DropdownItem, DropdownMenu, DropdownToggle,} from "reactstrap";
import "./index.css";
import assets from "../../../util/assets";

const SingleRowRequestComponent = (props) => {

    return (
        <div className="flex-vertical-center" key={`${props.type}-${props.id}`}>
            {
                props.type === "onetoone"
                ?
                    <CustomInput
                        type="radio"
                        id={`oneToOneRadio_${props.index}`}
                        name={`oneToOneRadio_${props.index}`}
                        value={`oneToOneRadio_${props.index}`}
                        checked={`oneToOneRadio_${props.index}` === props.isChecked}
                        onChange={props.radioToggle}
                        onClick={() => {
                            props.acceptRequestData(props.req_id, "onetoone");
                        }}
                    />
                    :
                    <CustomInput
                        type="checkbox"
                        id={`groupCheckbox_${props.index}`}
                        name={`groupCheckbox_${props.index}`}
                        value={props.req_id}
                        {...(props.selectAllCheckbox
                            ? {checked: props.selectAllCheckbox}
                            : {checked: props.checkboxStore.includes(props.req_id)})}
                        onChange={props.checkboxToggle}
                    />
            }

            <img
                className="img-fluid rounded-circle"
                src={props.userImage}
                alt="personspic"
                width="48"
                height="48"
            />
            {
                props.isFavourite ? <img className={"is-favourite-square"} alt={"favourite"} src={assets.is_favourite_circle}/> : ""
            }

            <div>
                <div className="request-title">{props.userName}</div>
                <div className="request-sub-title">{props.userRequest}</div>
            </div>
            <div className="request-last-child">
                <Dropdown
                    isOpen={props.dropdownOpen}
                    toggle={() => props.dropdownToggle()}
                    direction={"left"} style={{textAlign:'right'}}>
                    <DropdownToggle
                        color="link"
                        className="text-decoratin-none p-0">
                        <img src={props.dropdownOpen ? assets.more_selected : assets.more}
                             alt="personspic"/>
                    </DropdownToggle>
                    <DropdownMenu className="border-0 p-2 threeDotMenu"
                                  name={props.user_id}>
                        <DropdownItem
                            className="p-2 border-bottom"
                            onClick={() => {
                                props.isFavourite
                                    ? props.unFavorite(props.user_id, "one_to_one")
                                    : props.favorite(props.user_id, "one_to_one");
                            }}>
                            {props.isFavourite
                                ? "Unfavourite user"
                                : "Favourite user"}
                        </DropdownItem>
                        <DropdownItem
                            className="p-2 border-bottom"
                            onClick={() => {
                                props.blockUser(props.user_id, "one_to_one");
                            }}>
                            Block User
                        </DropdownItem>
                        <DropdownItem
                            className="p-2"
                            onClick={() => {
                                props.removeRequest(props.req_id, "one_to_one", props.user_id);
                            }}>
                            Remove
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <div className="request-hours-ago">. {props.userRequestHourAgo}</div>
            </div>
        </div>
    )
};

export default SingleRowRequestComponent;